<script>
  export default {
    name: 'RouteView',
    render: h => h('router-view')
  }
</script>
